import { render, staticRenderFns } from "./KonvaViewerTooltip.vue?vue&type=template&id=8b56769c&scoped=true"
import script from "./KonvaViewerTooltip.vue?vue&type=script&lang=js"
export * from "./KonvaViewerTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b56769c",
  null
  
)

export default component.exports